import { Injectable } from '@angular/core';
import { MenuItemHolder } from '../holders/menu-item-holder';
import { ItemDisplayData } from '../models/item-display-data';
import { Order } from '../models/order';
import { v4 as uuidv4 } from 'uuid';
import { CustomerService } from './customer.service';
import { Paycard } from '../models/paycard';
import { CurrentInfoService } from './current-info.service';
import { AppConfigService } from './app-config.service';
import { Orderpack } from '../models/orderpack';
import { Orderinfo } from '../models/orderinfo';
import { CloudFunctionsService } from './cloud-functions.service';
import { ComboHolder } from '../holders/combo-holder';
import { MenuItem, MenuItemDetailGroup } from '../models/menu-item';
import { DetailGroupPack } from '../models/detail-group-pack';
import { Detail } from '../models/detail';
import { Combo, ComboItemGroupModel } from '../models/combo';
import { LocaleService } from './locale.service';
import { CustomerAddress } from '../models/customer-address';
import { Card } from '../models/card';
import { StripePaymentInfo } from '../models/stripe-payment-info';
import { CouponModel } from '../models/coupon-model';
import { CouponBlueprint } from '../models/coupon-blueprint';
import { CouponHolder } from '../holders/coupon-holder';
import { Platform } from '@angular/cdk/platform';
import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})

export class CurrentOrderService 
{
  private paycard:Paycard = new Paycard();
  private order:Order = new Order();
  private itens:Array<MenuItemHolder> = new Array<MenuItemHolder>();
  private combos:Array<ComboHolder> = new Array<ComboHolder>();
  private adress:CustomerAddress | undefined;
  private fee:number = 0;
  private currentCombo:ComboHolder | null = null;

  private _lastItemAdded:any = '';
  private _shouldShowLastItemAdded:boolean = false;
  private _shouldShowOrderSent:boolean = false;
  private orderBaseData: any;
  private carDescription: any;
  private payCardData:any;
  private card:Card | undefined;

  private currentCoupon: CouponModel | undefined;

  constructor(
    private customerservice:CustomerService,
    private currentinfoservice:CurrentInfoService,
    private appconfigservice:AppConfigService,
    private cloudfunctionsservice:CloudFunctionsService,
    private localeservice:LocaleService,
    private platform: Platform,
    private device: DeviceDetectorService
  ) { }

  public setOrderType(type:number)
  {
    this.order.Type = type;
  }

  public setTable(tableNumber:number)
  {
    this.order.Table = tableNumber;
  }

  public getOrderType():number
  {
    return this.order.Type;
  }

  public getCurrentAdress()
  {
    return this.adress;
  }

  public getTableNumber():number
  {
    return this.order.Table;
  }

  public setBaseData(data:{ scheduled:boolean, scheduledfor:string, paymode:number, needschange:number, changefor:number })
  {
    this.orderBaseData = data;
  }

  public getBaseData()
  {
    var data = { scheduled:false, scheduledfor:'00:00', paymode:-1, needschange:-1, changefor:0 };

    Object.assign(data, this.orderBaseData);

    return data;
  }

  public setPayCardData(data:{ hasPayCard:number, payCardNumber:number })
  {
    this.payCardData = data;
  }

  public getPayCardData()
  {
    var data = { hasPayCard:-1, payCardNumber:0 };

    Object.assign(data, this.payCardData);

    return data;
  }

  public setCarDescription(data:{ reference:string, model:string, color:string })
  {
    this.carDescription = data;
  }

  public getCarDescription()
  {
    var data = { reference:'', model:'', color:'' };

    Object.assign(data, this.carDescription);

    return data;
  }

  public getCarDescriptionString()
  {
    return `${this.carDescription.Model} ${this.carDescription.Color} - ${this.carDescription.Reference}`;
  }

  public setCoupon(couponHolder:CouponHolder)
  {
    var couponValue = 0;

    if(couponHolder.Blueprint.Mode == 0)
      couponValue = couponHolder.Blueprint.Value;
    else
      couponValue = parseFloat((this.getCurrentPrice(false, false) * (couponHolder.Blueprint.Percentage / 100)).toFixed(2))

    this.currentCoupon = new CouponModel(couponHolder.Blueprint.ID, couponHolder.Blueprint.Name, couponHolder.ValueString, couponValue, `-${this.localeservice.getCurrencyString(couponValue)}`, couponHolder.Blueprint.FloorValue,couponHolder.Blueprint.Mode, couponHolder.Blueprint.Value, couponHolder.Blueprint.Percentage);
  }

  public updateCoupon()
  {
    if(this.currentCoupon)
      {
        if(this.currentCoupon.Mode == 1)
        {
          var couponValue = parseFloat((this.getCurrentPrice(false, false) * (this.currentCoupon.Percentage / 100)).toFixed(2))

          this.currentCoupon.FinalValue = couponValue;
          this.currentCoupon.FinalValueString = this.localeservice.getCurrencyString(this.currentCoupon.FinalValue);
        }
      }
  }

  public getCoupon()
  {
    return this.currentCoupon;
  }

  public clearCoupon()
  {
    this.currentCoupon = undefined;
  }

  public addItem(itemHolder:MenuItemHolder)
  {
    this.itens.push(itemHolder);

    this._lastItemAdded = itemHolder;
    this._shouldShowLastItemAdded = true;
  }

  public removeItem(itemid:string)
  {
    var idx = this.itens.findIndex(item => item.ID === itemid);

    if(idx > -1)
    {
      this.itens.splice(idx, 1);

      return true;
    }

    return false;
  }

  public saveItem(itemHolder:MenuItemHolder)
  {
    var index = this.itens.findIndex(holder => holder.MenuItem.ID === itemHolder.MenuItem.ID);

    if(index > -1)
    {
      this.itens.splice(index,1,itemHolder);

      return true;
    }
    else
      return false;
  }

  public getItem(itemuid:string)
  {
    var holder = this.itens.find(itemHolder => itemHolder.ID === itemuid);

    if(holder !== undefined)
    {
      var newHolder = new MenuItemHolder();

      var itemCopy = new MenuItem();

      Object.assign(itemCopy, holder.MenuItem);

      itemCopy.setData(holder.MenuItem);

      newHolder.MenuItem = itemCopy;

      var newDetailPacks = new Array<DetailGroupPack>();

      for (let index = 0; index < holder.DetailGroupPacks.length; index++) 
      {
        const detailGroupPack = holder.DetailGroupPacks[index];
        
        var newDetailGroupPack = new DetailGroupPack(this.localeservice);

        var newDetailGroup = new MenuItemDetailGroup();

        Object.assign(newDetailGroup, detailGroupPack.DetailGroup);

        newDetailGroup.setData(detailGroupPack.DetailGroup);

        newDetailGroupPack.DetailGroup = newDetailGroup;

        var newDetails = new Array<Detail>();

        for (let index = 0; index < detailGroupPack.DetailList.length; index++) 
        {
          const detail = detailGroupPack.DetailList[index];

          var newDetail = new Detail();

          Object.assign(newDetail, detail);
          
          newDetails.push(newDetail);
        }

        newDetailGroupPack.DetailList = newDetails;

        newDetailGroupPack.updateHasSelection();

        newDetailPacks.push(newDetailGroupPack);
      }

      newHolder.DetailGroupPacks = newDetailPacks;

      return newHolder;
    }
    else
      return new MenuItemHolder();
  }

  public addCombo(comboHolder:ComboHolder)
  {
    this.combos.push(comboHolder);

    this._lastItemAdded = comboHolder;
    this._shouldShowLastItemAdded = true;
  }

  public removeCombo(comboid:string)
  {
    var idx = this.combos.findIndex(combo => combo.ID === comboid);

    if(idx > -1)
    {
      this.combos.splice(idx, 1);

      return true;
    }

    return false;
  }

  public saveCombo(comboHolder:ComboHolder)
  {
    var index = this.combos.findIndex(holder => holder.ID === comboHolder.ID);

    if(index > -1)
    {
      this.combos.splice(index,1,comboHolder);

      return true;
    }
    else
      return false;
  }

  public getCombo(combouid:string)
  {
    var comboHolder = this.combos.find(combo => combo.ID === combouid);

    var newComboHolder = new ComboHolder();

    if(comboHolder !== undefined)
    {
      var newCombo = new Combo();

      Object.assign(newCombo, comboHolder.Combo);

      newCombo.setData(comboHolder.Combo);

      newComboHolder.Combo = newCombo;

      for (let index = 0; index < comboHolder.ComboItemHolders.length; index++) 
      {
        const holder = comboHolder.ComboItemHolders[index];
        
        var newHolder = new MenuItemHolder();

        var itemCopy = new MenuItem();

        Object.assign(itemCopy, holder.MenuItem);

        itemCopy.setData(holder.MenuItem);

        newHolder.MenuItem = itemCopy;

        var newDetailPacks = new Array<DetailGroupPack>();

        for (let index = 0; index < holder.DetailGroupPacks.length; index++) 
        {
          const detailGroupPack = holder.DetailGroupPacks[index];
          
          var newDetailGroupPack = new DetailGroupPack(this.localeservice);

          var newDetailGroup = new MenuItemDetailGroup();

          Object.assign(newDetailGroup, detailGroupPack.DetailGroup);

          newDetailGroup.setData(detailGroupPack.DetailGroup);

          newDetailGroupPack.DetailGroup = newDetailGroup;

          var newDetails = new Array<Detail>();

          for (let index = 0; index < detailGroupPack.DetailList.length; index++) 
          {
            const detail = detailGroupPack.DetailList[index];

            var newDetail = new Detail();

            Object.assign(newDetail, detail);
            
            newDetails.push(newDetail);
          }

          newDetailGroupPack.DetailList = newDetails;

          newDetailGroupPack.updateHasSelection();

          newDetailPacks.push(newDetailGroupPack);
        }

        newHolder.DetailGroupPacks = newDetailPacks;

        newComboHolder.ComboItemHolders.push(newHolder);
      }
    }

    return newComboHolder;
  }

  public setCurrentCombo(comboHolder:ComboHolder)
  {
    if(this.currentCombo === null)
      this.currentCombo = comboHolder;
  }

  public getCurrentCombo()
  {
    if(this.currentCombo !== null)
      return this.currentCombo;
    else
      return new ComboHolder();
  }

  public checkCurrentNewCombo(combouuid:string)
  {
    return this.currentCombo !== null && this.currentCombo.Combo.UniversalID === combouuid;
  }

  public checkCurrentEditCombo(combouuid:string)
  {
    return this.currentCombo !== null && this.currentCombo.Combo.ID === combouuid;
  }

  public getComboItem(itemuuid:string)
  {
    if(this.currentCombo === null)
      return new MenuItemHolder();

    var holder = this.currentCombo.ComboItemHolders.find(itemHolder => itemHolder.ID === itemuuid);

    if(holder !== undefined)
    {
      var newHolder = new MenuItemHolder();

      var itemCopy = new MenuItem();

      Object.assign(itemCopy, holder.MenuItem);

      itemCopy.setData(holder.MenuItem);

      newHolder.MenuItem = itemCopy;

      var newDetailPacks = new Array<DetailGroupPack>();

      for (let index = 0; index < holder.DetailGroupPacks.length; index++) 
      {
        const detailGroupPack = holder.DetailGroupPacks[index];
        
        var newDetailGroupPack = new DetailGroupPack(this.localeservice);

        var newDetailGroup = new MenuItemDetailGroup();

        Object.assign(newDetailGroup, detailGroupPack.DetailGroup);

        newDetailGroup.setData(detailGroupPack.DetailGroup);

        newDetailGroupPack.DetailGroup = newDetailGroup;

        var newDetails = new Array<Detail>();

        for (let index = 0; index < detailGroupPack.DetailList.length; index++) 
        {
          const detail = detailGroupPack.DetailList[index];

          var newDetail = new Detail();

          Object.assign(newDetail, detail);
          
          newDetails.push(newDetail);
        }

        newDetailGroupPack.DetailList = newDetails;

        newDetailGroupPack.updateHasSelection();

        newDetailPacks.push(newDetailGroupPack);
      }

      newHolder.DetailGroupPacks = newDetailPacks;

      for (let index = 0; index < newHolder.DetailGroupPacks.length; index++) 
      {
        const element = newHolder.DetailGroupPacks[index];
        
        if(element.DetailGroup.LimitSelection)
          element.updateLimitSelectionDescription()

        if(element.DetailGroup.LimitMacroSelection)
          element.updateLimitSelectionDescription(newHolder.getMacroSelectionCount(element.DetailGroup.MacroID), element.DetailGroup.MacroMinSelectionCount);
      }

      return newHolder;
    }
    else
      return new MenuItemHolder();
  }

  public saveComboItem(itemHolder:MenuItemHolder)
  {
    if(this.currentCombo === null)
      return false;

    var index = this.currentCombo.ComboItemHolders.findIndex(holder => holder.MenuItem.ID === itemHolder.MenuItem.ID);

    if(index > -1)
    {
      this.currentCombo.ComboItemHolders.splice(index,1,itemHolder);

      return true;
    }
    else
      return false;
  }

  public addComboItem(itemHolder:MenuItemHolder, itemGroup:ComboItemGroupModel)
  {
    if(this.currentCombo === null)
      return false;

    this.currentCombo.ComboItemHolders.push(itemHolder);

    itemGroup.CurrentItem = itemHolder.ID;
    itemGroup.ItemName = itemHolder.CountName;
    itemGroup.IsEmpty = false;

    return true;
  }

  public changeComboItem(itemHolder:MenuItemHolder, oldItemID:string, itemGroup:ComboItemGroupModel)
  {
    if(this.currentCombo === null)
      return false;
    
    if(itemGroup.IsEmpty)
    {
      this.currentCombo.ComboItemHolders.push(itemHolder);

      itemGroup.CurrentItem = itemHolder.ID;
      itemGroup.ItemName = itemHolder.CountName;
      itemGroup.IsEmpty = false;

      return true;
    }

    var index = this.currentCombo.ComboItemHolders.findIndex(holder => holder.MenuItem.ID === oldItemID);

    if(index > -1)
    {
      this.currentCombo.ComboItemHolders.splice(index, 1, itemHolder);

      itemGroup.CurrentItem = itemHolder.ID;
      itemGroup.ItemName = itemHolder.CountName;

      return true;
    }
    else
      return false;
  }

  public setNoComboItem(itemGroup:ComboItemGroupModel)
  {
    if(this.currentCombo === null)
      return;

    var index = this.currentCombo.ComboItemHolders.findIndex(holder => holder.MenuItem.ID === itemGroup.CurrentItem);

    if(index > -1)
    {
      this.currentCombo.ComboItemHolders.splice(index, 1);

      itemGroup.CurrentItem = "";
      itemGroup.ItemName = "";
    }

    itemGroup.IsEmpty = true;
    itemGroup.IsOptionalOkay = true;
  }

  public getCurrentComboPrice()
  {
    if(this.currentCombo != null)
      return this.currentCombo.CurrentPrice;
    else
      return 0;
  }

  public getComboItemGroup(itemgroupuid:string)
  {
    if(this.currentCombo != null)
    {
      var comboItemGroup = this.currentCombo.Combo.ItemGroupsList.find(itemGroup => itemGroup.ID === itemgroupuid);

      if(comboItemGroup !== undefined)
        return comboItemGroup;
    }
    
    return new ComboItemGroupModel();
  }

  public getCurrentComboCount()
  {
    if(this.currentCombo != null)
      return this.currentCombo.Combo.ComboCount;
    else
      return 0;
  }

  public clearCurrentCombo()
  {
    this.currentCombo = null;
  }

  public clear()
  {
    this.paycard = new Paycard();
    this.paycard.ID = uuidv4();

    this.order = new Order();
    this.order.ID = uuidv4();

    if(this.platform.ANDROID)
      this.order.Platform =1;

    if(this.platform.IOS)
      this.order.Platform = 2; 

    if(this.device.isTablet())
      this.order.Device = 1;

    if(this.device.isDesktop())
      this.order.Device = 2;

    this.order.Type = -1;
    this.order.Table = 0;

    this.itens = new Array<MenuItemHolder>();
    this.combos = new Array<ComboHolder>();

    this.orderBaseData = undefined;
    this.carDescription = undefined;
    this.payCardData = undefined;

    this.clearCoupon();
    
    this.clearAdress();
  }

  public getOrderItemCount()
  {
    return this.itens.length + this.combos.length;
  }

  public getLastAddedItem()
  {
    return this._lastItemAdded;
  }

  public setAdress(adress:CustomerAddress)
  {
    this.adress = adress;

    this.setFee();
  }

  public clearAdress()
  {
    this.adress = undefined;

    this.clearFee();
  }

  public setAdressInfo()
  {
    if(this.adress)
    {
      this.order.DeliveryLocationName = this.adress.Location;
      this.order.PlaceReference = this.adress.Reference;
      this.order.Neighbourhood = this.adress.Neighborhood;
      this.order.Street = this.adress.Street;
      this.order.PlaceNumber = this.adress.Number;

      this.order.FullAddress = this.adress.AddressString;
      this.order.AddressUrl = this.adress.Url;
    }
  }

  public setCouponInfo()
  {
    if(this.currentCoupon)
    {
      this.order.Coupon = this.currentCoupon;

      let usedCouponsData = localStorage.getItem("UsedCoupons")

      if(usedCouponsData)
      {
        var usedCoupons = <Array<{ID:string, Timestamp:number}>> JSON.parse(usedCouponsData);

        if(usedCoupons)
        {
          var indx = usedCoupons.findIndex(x => x.ID === this.currentCoupon?.ID);

          if(indx > -1)
            usedCoupons.splice(indx, 1, { ID:this.currentCoupon.ID, Timestamp: Date.now() / 1000});
          else
            usedCoupons.push({ ID:this.currentCoupon.ID, Timestamp: Date.now() / 1000});

          localStorage.setItem("UsedCoupons",JSON.stringify(usedCoupons));
        }
      }
      else
      {
        var usedCoupons = new Array<{ID:string, Timestamp:number}>();

        usedCoupons.push({ ID:this.currentCoupon.ID, Timestamp: Date.now() / 1000});

        localStorage.setItem("UsedCoupons",JSON.stringify(usedCoupons));
      }
    }
  }

  setFee()
  {
    if (this.currentinfoservice._currentInfo.ChargeByDistance === true)
    {
        var extraFee = 0;

        if (this.adress && this.adress.Distance > this.currentinfoservice._currentInfo.InitialDistance)
            extraFee = (this.adress.Distance - this.currentinfoservice._currentInfo.InitialDistance) * this.currentinfoservice._currentInfo.FeeByDistanceUnit;

        this.fee = this.currentinfoservice._currentInfo.InitialFee + extraFee;

        return;
    }

    if (this.currentinfoservice._currentInfo.ChargeByRegion && this.adress)
    {
        var deliveryRegion = this.currentinfoservice.GetDeliveryRegion(this.adress.Distance);

        if(deliveryRegion)
            this.fee = deliveryRegion.Fee;

        return;
    }
  }

  public clearFee()
  {
    this.fee = 0;
  }

  public checkFee()
  {
    if(this.order.Type === 2)
    {
      if (this.currentinfoservice._currentInfo.ChargeDeliveryFee === true)
          this.fee = this.currentinfoservice._currentInfo.DeliveryFee;

      if(this.currentinfoservice._currentInfo.ChargeByValue && this.getCurrentPrice(false, false) < this.currentinfoservice._currentInfo.ValueThreshold)
        this.fee = this.currentinfoservice._currentInfo.ByValueFee;
    }
  }

  public getAdress()
  {
    return this.adress;
  }

  public shouldShowItemAddedPage()
  {
    if(this._shouldShowLastItemAdded === true)
    {
      this._shouldShowLastItemAdded = false;

      return true;
    }

    return false;
  }

  public getCurrentPrice(includefee:boolean, includecoupon:boolean)
  {
    let currentPrice = 0.0;

    if(includefee === true)
      currentPrice += this.fee;

    if(includecoupon === true && this.currentCoupon)
      currentPrice -= this.currentCoupon.FinalValue;

    for (let index = 0; index < this.itens.length; index++) 
    {
      const menuItemHolder = this.itens[index];
      
      currentPrice += menuItemHolder.CurrentPrice;
    }

    for (let index = 0; index < this.combos.length; index++) 
    {
      const combHolder = this.combos[index];
      
      currentPrice += combHolder.CurrentPrice;
    }

    return currentPrice;
  }

  isAboveFloor()
  {
    var currentPrice = this.getCurrentPrice(false, false);

    return currentPrice >= this.currentinfoservice.getFloorValue();
  }

  hasFee()
  {
    return this.fee > 0;
  }

  getFeeString()
  {
    return this.localeservice.getCurrencyString(this.fee);
  }

  public getCurrentPriceString(includefee:boolean, includecoupon:boolean)
  {
    return this.localeservice.getCurrencyString(this.getCurrentPrice(includefee, includecoupon));
  }

  public getOrderItensDisplayData()
  {
    var itens = new Array<ItemDisplayData>();

    for (let index = 0; index < this.combos.length; index++) 
    {
      const combo = this.combos[index];

      var originalPriceString = '';

      if(combo.Combo.OriginalPrice > 0 && combo.Combo.OriginalPrice > combo.Combo.DefaultPrice)
        originalPriceString = this.localeservice.getCurrencyString(combo.Combo.OriginalPrice);
      
      const displayData = new ItemDisplayData(combo.ID,combo.UniversalID, combo.Combo.Icon, combo.Combo.Picture, combo.CountName, combo.Summary, originalPriceString,this.localeservice.getCurrencyString(combo.CurrentPrice), 'combo', false, this.getComboWaitTimeString(combo));

      itens.push(displayData);
    }

    for (let index = 0; index < this.itens.length; index++) 
    {
      const menuItemHolder = this.itens[index];
      
      var originalPriceString = '';

      if(menuItemHolder.MenuItem.OriginalPrice > 0 && menuItemHolder.MenuItem.OriginalPrice > menuItemHolder.MenuItem.DefaultPrice)
        originalPriceString = this.localeservice.getCurrencyString(menuItemHolder.MenuItem.OriginalPrice);

      const displayData = new ItemDisplayData(menuItemHolder.ID,menuItemHolder.UniversalID, menuItemHolder.MenuItem.Icon, menuItemHolder.MenuItem.Picture, menuItemHolder.CountName, menuItemHolder.Summary, originalPriceString,this.localeservice.getCurrencyString(menuItemHolder.CurrentPrice), 'item', false, this.getItemWaitTimeString(menuItemHolder));

      itens.push(displayData);
    }

    return itens;
  }

  getComboWaitTimeString(combo:ComboHolder)
  {
    var waitTime = 0;

    for (let index = 0; index < combo.ComboItemHolders.length; index++) 
    {
      const itemHolder = combo.ComboItemHolders[index];
      
      var itemWaitTime = this.getItemWaitTime(itemHolder);

      if(itemWaitTime > waitTime)
        waitTime = itemWaitTime;
    }

    var min = this.currentinfoservice.getMinutes(waitTime);

    if(min < 60)
      return `${min}min`;
    else
      return `${min/60}h`
  }

  getItemWaitTime(item:MenuItemHolder)
  {
    var tags = new Array<string>();

    for (let index = 0; index < item.Tags.length; index++) 
    {
      const tag = item.Tags[index];
      
      tags.push(tag);
    }

    var orderWaitTime = this.currentinfoservice.getWaitTime(this.order.Type);
    var tagWaitTime = this.currentinfoservice.getTagWaitTime(tags);

    return orderWaitTime + tagWaitTime;
  }

  getItemWaitTimeString(item:MenuItemHolder)
  {
    var min = this.currentinfoservice.getMinutes(this.getItemWaitTime(item));

    if(min < 60)
      return `${min}min`;
    else
      return `${min/60}h`
  }

  public getTags()
  {
    var tags = new Array<string>();

    for (let index = 0; index < this.combos.length; index++) 
    {
      const comboHolder = this.combos[index];
      
      for (let index = 0; index < comboHolder.Tags.length; index++) 
      {
        const tag = comboHolder.Tags[index];
        
        tags.push(tag);
      }
    }

    for (let index = 0; index < this.itens.length; index++) 
    {
      const itemHolder = this.itens[index];
      
      for (let index = 0; index < itemHolder.Tags.length; index++) 
      {
        const tag = itemHolder.Tags[index];
        
        tags.push(tag);
      }
    }

    return tags;
  }

  public getWaitTime()
  {
    var waitTime = this.currentinfoservice.getWaitTime(this.order.Type);
    var tagWaitTime = this.currentinfoservice.getTagWaitTime(this.getTags());

    return waitTime + tagWaitTime;
  }

  public getWaitTimeString()
  {
    var minutes = this.currentinfoservice.getMinutes(this.getWaitTime());

    if(minutes < 60)
      return `${minutes}min`;
    else
      return `${minutes/60}h`
  }

  public setCustomer()
  {
    var customerData = this.customerservice.getCustomerData();

    this.order.CustomerName = customerData.Name;
    this.order.CustomerPhone = customerData.Phone;
    this.order.SenderID = customerData.ID;
  }

  setBaseDataInfo()
  {
    var currentDateTime = new Date();

    this.order.Scheduled = this.orderBaseData.scheduled === true;

    if(this.order.Scheduled === true)
    {
      var scheduledForStringArray = String(this.orderBaseData.scheduledfor).split(":");

      currentDateTime.setHours(Number(scheduledForStringArray[0]), Number(scheduledForStringArray[1]), 0, 0);

      this.order.ScheduledTimestamp = currentDateTime.valueOf() / 1000;
    }

    if(this.order.Type === 2 || this.order.Type === 4)
    {
      this.order.NeedsChange = this.orderBaseData.needschange === 1;

      if(this.order.NeedsChange === true)
        this.order.ChangeFor = String(this.orderBaseData.changefor);

      this.order.PaymentMode = Number(this.orderBaseData.paymode);
    }
  }

  public async sendOrder()
  {
    if(this.order.Type > 0)
    {
      this.setBaseDataInfo();

      if(this.order.Type === 2)
      {
        this.setAdressInfo();

        this.order.Fee = this.fee;
      }

      if(this.order.Type === 4)
        this.order.PlaceReference = this.getCarDescriptionString();
    }

    this.setCouponInfo();

    this.setCustomer();

    this.paycard.LastOrderID = this.order.ID;

    this.paycard.Origin = 2;

    this.order.PayCardID = this.paycard.ID;

    this.order.Status = 0;

    this.order.WaitTime = this.getWaitTime();

    this.order.Origin = 2;

    var platform = this.appconfigservice.getOperatingSystem();

    if(platform === "Android")
      this.order.Platform = 1;

    if(platform === "iOS")
      this.order.Platform = 2;

    this.clearDetails();

    this.setVerificationCount();

    this.setRelations();

    var data =
    {
      customerID: this.customerservice.getCustomerID(),
      clientID: this.appconfigservice.getClientID(),
      unitID: this.appconfigservice.getUnitID(),
      hasPayCard: this.payCardData?.hasPayCard | 0,
      payCardNumber: this.payCardData?.payCardNumber | 0
    }

    try
    {
      var result = await this.cloudfunctionsservice.callPlaceOrderPack(data,this.getOrderPack(), this.getOrderInfoHolder());

      return result === 'success';
    }
    catch(error)
    {
      return false;
    }
  }

  setShowOrderSent()
  {
    this._shouldShowOrderSent = true;
  }

  getShowOrderSent()
  {
    if(this._shouldShowOrderSent === true)
    {
      this._shouldShowOrderSent = false;

      return true;
    }

    return false;
  }

  clearDetails()
  {
    for (let index = 0; index < this.combos.length; index++) 
    {
      const comboHolder = this.combos[index];
      
      for (let index = 0; index < comboHolder.ComboItemHolders.length; index++) 
      {
        const menuItemHolder = comboHolder.ComboItemHolders[index];
        
        for (let index = 0; index < menuItemHolder.DetailGroupPacks.length; index++) 
        {
          const detailGroupPack = menuItemHolder.DetailGroupPacks[index];
          
          detailGroupPack.clearForSubmission();
        }
      }
    }

    for (let index = 0; index < this.itens.length; index++) 
    {
      const menuItemHolder = this.itens[index];
      
      for (let index = 0; index < menuItemHolder.DetailGroupPacks.length; index++) 
      {
        const detailGroupPack = menuItemHolder.DetailGroupPacks[index];
        
        detailGroupPack.clearForSubmission();
      }
    }
  }

  setVerificationCount()
  {
    this.order.ItemCount = this.itens.length + this.combos.length;

    for (let index = 0; index < this.combos.length; index++) 
    {
      const comboHolder = this.combos[index];

      comboHolder.Combo.ItemCount = comboHolder.ComboItemHolders.length;

      for (let index = 0; index < comboHolder.ComboItemHolders.length; index++) 
      {
        const menuItemHolder = comboHolder.ComboItemHolders[index];

        for (let index = 0; index < menuItemHolder.DetailGroupPacks.length; index++) 
        {
          const detailGroupPack = menuItemHolder.DetailGroupPacks[index];
          
          menuItemHolder.MenuItem.DetailCount += detailGroupPack.getVerficationCount();
        }
      }
    }

    for (let index = 0; index < this.itens.length; index++) 
    {
      const menuItemHolder = this.itens[index];

      for (let index = 0; index < menuItemHolder.DetailGroupPacks.length; index++) 
      {
        const detailGroupPack = menuItemHolder.DetailGroupPacks[index];
        
        menuItemHolder.MenuItem.DetailCount += detailGroupPack.getVerficationCount();
      }
    }
  }

  setRelations()
  {
    for (let index = 0; index < this.combos.length; index++) 
    {
      const comboHolder = this.combos[index];

      comboHolder.Combo.OrderID = this.order.ID;

      for (let index = 0; index <  comboHolder.ComboItemHolders.length; index++) 
      {
        const menuItemHolder = comboHolder.ComboItemHolders[index];

        menuItemHolder.MenuItem.OrderID = this.order.ID;
        menuItemHolder.MenuItem.ComboID = comboHolder.ID;

        for (let index = 0; index < menuItemHolder.DetailGroupPacks.length; index++) 
        {
          const detailGroupPack = menuItemHolder.DetailGroupPacks[index];
          
          detailGroupPack.setRelation(this.order.ID, menuItemHolder.MenuItem.ID)
        }
      }
    }

    for (let index = 0; index < this.itens.length; index++) 
    {
      const menuItemHolder = this.itens[index];

      menuItemHolder.MenuItem.OrderID = this.order.ID;

      for (let index = 0; index < menuItemHolder.DetailGroupPacks.length; index++) 
      {
        const detailGroupPack = menuItemHolder.DetailGroupPacks[index];
        
        detailGroupPack.setRelation(this.order.ID, menuItemHolder.MenuItem.ID)
      }
    }
  }

  getOrderPack()
  {
    var pack = new Orderpack();

    pack.PayCard = this.paycard;
    pack.Order = this.order;
    for (let index = 0; index < this.combos.length; index++) 
    {
      const comboHolder = this.combos[index];
      
      pack.Combos.push(comboHolder.Combo);

      for (let index = 0; index < comboHolder.ComboItemHolders.length; index++) 
      {
        const menuItemHolder = comboHolder.ComboItemHolders[index];
        
        pack.MenuItems.push(menuItemHolder.MenuItem);

        for (let index = 0; index < menuItemHolder.DetailGroupPacks.length; index++) 
        {
          const detailGroupPack = menuItemHolder.DetailGroupPacks[index];
          
          for (let index = 0; index < detailGroupPack.DetailList.length; index++) 
          {
            const detail = detailGroupPack.DetailList[index];
            
            pack.Details.push(detail);
          }
        }
      }
    }

    for (let index = 0; index < this.itens.length; index++) 
    {
      const menuItemHolder = this.itens[index];
      
      pack.MenuItems.push(menuItemHolder.MenuItem);

      for (let index = 0; index < menuItemHolder.DetailGroupPacks.length; index++) 
      {
        const detailGroupPack = menuItemHolder.DetailGroupPacks[index];
        
        for (let index = 0; index < detailGroupPack.DetailList.length; index++) 
        {
          const detail = detailGroupPack.DetailList[index];
          
          pack.Details.push(detail);
        }
      }
    }

    return pack;
  }

  GetPaymentInfo()
  {
      if(this.card && this.order.PaymentMode == 5)
        return new StripePaymentInfo(this.getCurrentPrice(true, true) * 100, this.localeservice.getCurrency(), this.card.ID, `Pagamentos para o pedido ${this.order.ID}`, this.card.StripeCustomerID);

      return undefined;
  }

  getOrderInfoHolder()
  {
      var infoHolder = new Orderinfo();

      infoHolder.OrderID = this.order.ID;
      infoHolder.UnitID = this.appconfigservice.getUnitID();
      infoHolder.ClientID = this.appconfigservice.getClientID();
      infoHolder.CustomerID = this.customerservice.getCustomerID();
      infoHolder.Name = `${this.localeservice.instantTranslation("Order.NamePrefix")} ${this.order.Number}`;
      infoHolder.Description = this.GetRetrievalModeString(this.order.Type);
      infoHolder.Summary = this.getOrderSummary();

      return infoHolder;
  }

  getOrderSummary()
  {
    var text = "";

    text += `${this.localeservice.instantTranslation("OrderSummary.Mode")}: ${this.GetRetrievalModeString(this.order.Type)}`;

    if (this.order.Scheduled === true)
        text += `\n${this.localeservice.instantTranslation("OrderSummary.Scheduled")}: ${this.getOrderTimeString}`;

    if (this.order.Type === 2)
    {
      if(this.order.FullAddress.length > 0)
        text += `\n${this.localeservice.instantTranslation("OrderSummary.Address")}: ${this.order.FullAddress}`;
      else
        text += `\n${this.localeservice.instantTranslation("OrderSummary.Address")}: ${this.order.DeliveryLocationName} ${this.order.Street} ${this.order.PlaceNumber} ${this.order.Neighbourhood} ${this.order.PlaceReference}`;

      if (this.order.PaymentMode === 0)
      {
        if (this.order.NeedsChange)
            text += `\n${this.localeservice.instantTranslation("OrderSummary.PaymentMode")}: ${this.localeservice.instantTranslation("OrderSummary.Money")}\n${this.localeservice.instantTranslation("OrderSummary.ChangeFor")}: ${this.order.ChangeFor}`;
        else
            text += `\n${this.localeservice.instantTranslation("OrderSummary.PaymentMode")}: ${this.localeservice.instantTranslation("OrderSummary.Money")}\n${this.localeservice.instantTranslation("OrderSummary.ChangeFor")}: ${this.localeservice.instantTranslation("OrderSummary.NoChange")}`;
      }
      else if(this.order.PaymentMode === 1)
        text += `\n${this.localeservice.instantTranslation("OrderSummary.PaymentMode")}: ${this.localeservice.instantTranslation("OrderSummary.Card")}`;
    }

    if (this.order.Type === 4)
    {
      text += `\n${this.localeservice.instantTranslation("OrderSummary.Reference")}: ${this.order.PlaceReference}`;

      if (this.order.PaymentMode === 0)
      {
        if (this.order.NeedsChange)
          text += `\n${this.localeservice.instantTranslation("OrderSummary.PaymentMode")}: ${this.localeservice.instantTranslation("OrderSummary.Money")}\n${this.localeservice.instantTranslation("OrderSummary.ChangeFor")}: ${this.order.ChangeFor}`;
        else
          text += `\n${this.localeservice.instantTranslation("OrderSummary.PaymentMode")}: ${this.localeservice.instantTranslation("OrderSummary.Money")}\n${this.localeservice.instantTranslation("OrderSummary.ChangeFor")}: ${this.localeservice.instantTranslation("OrderSummary.NoChange")}`;
      }
      else if(this.order.PaymentMode === 1)
        text += `\n${this.localeservice.instantTranslation("OrderSummary.PaymentMode")}: ${this.localeservice.instantTranslation("OrderSummary.Card")}`;
    }

    text += `\n\n${this.localeservice.instantTranslation("OrderSummary.Itens")}:\n\n`;

    var orderItems = this.getOrderItensDisplayData();

    for (let index = 0; index < orderItems.length; index++) 
    {
      const element = orderItems[index];
      
      text += `<${element.Name}>\n${element.Description}\n${index < orderItems.length -1 ? '\n' : ''}`;
    }

    if(this.fee > 0 || this.currentCoupon)
    {
      text +="\n";

      if(this.fee > 0)
        text += `\n${this.localeservice.instantTranslation("OrderSummary.DeliveryFee")}: ${this.localeservice.getCurrencyString(this.fee)}`;

      if(this.currentCoupon)
        text += `\n${this.currentCoupon.Name}: ${this.currentCoupon.FinalValueString}`;

      text += `\n${this.localeservice.instantTranslation("OrderSummary.OrderValue")}: ${this.localeservice.getCurrencyString(this.getCurrentPrice(false,false))}`;
    }

    text += `\n\n${this.localeservice.instantTranslation("OrderSummary.TotalValue")}: ${this.getCurrentPriceString(true, true)}`;

    return text;
  }

  public getOrderTimeString()
  {
      var dateTime = new Date(this.order.Timestamp * 1000);

      var dateTimeNow = new Date();

      if (dateTime.getFullYear() == dateTimeNow.getFullYear() && dateTime.getMonth() == dateTimeNow.getMonth() &&  dateTime.getDate() == dateTimeNow.getDate())
          return dateTime.toLocaleTimeString(undefined , { hour: '2-digit', minute: '2-digit' });
      else

      return dateTime.toLocaleDateString() + ' - ' + dateTime.toLocaleTimeString(undefined , { hour: '2-digit', minute: '2-digit' });
  }


  public GetRetrievalModeString(mode:number)
  {
    switch (mode)
    {
      case 0:
          return `${this.localeservice.instantTranslation("RetrievalMode.Table")} ${this.order.Table}`;
      case 1:
          return this.localeservice.instantTranslation("RetrievalMode.Balcony");
      case 2:
          return this.localeservice.instantTranslation("RetrievalMode.Delivery");
      case 3:
          return this.localeservice.instantTranslation("RetrievalMode.WillComeHere");
      case 4:
          return this.localeservice.instantTranslation("RetrievalMode.Drive");
      default:
          return "?????";
    }
  }
}
